/** Rate-limit scope keys (`tenantId:action` or `tenantId:userId:action`). */
export const RATE_LIMIT_ACTION = {
  SEND_MESSAGE: "send-message",
  JOIN_ROOM: "join-room",
  TYPING: "typing",
  CALL_START: "call-start",
  CALL_TOKEN_REFRESH: "call-token-refresh",
  UPLOAD_PRESIGN: "upload-presign",
} as const;

export type RateLimitAction = (typeof RATE_LIMIT_ACTION)[keyof typeof RATE_LIMIT_ACTION];
